import { Methods } from '@api/follow/unlink'
import { Request } from '../../request'
export default async (query:Methods["get"]["query"]) => Request( client => client.follow.unlink.$get({query}) )
